if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value(search: string, pos: number) {
      const posIndex = !pos || pos < 0 ? 0 : +pos

      // tslint:disable:no-unsafe-any
      return this.substring(posIndex, posIndex + search.length) === search
    },
  })
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (search, thisLen) {
    let len = thisLen
    if (len === undefined || len > this.length) {
      len = this.length
    }

    return this.substring(len - search.length, len) === search
  }
}
